import script from "./BaseDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./BaseDropdown.vue?vue&type=style&index=0&id=d9955514&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9955514"]])

export default __exports__